import React, { lazy } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import moment from 'moment';
import routesPaths from './routesPaths';
import { dateToUrlDate } from '../shared/functions';
// views
var LazyNewspaperPage = lazy(function () { return import(/* webpackPrefetch: true */ '../views/NewspaperPage'); });
var LazyNewspaperDetail = lazy(function () { return import(/* webpackPrefetch: true */ '../views/NewspaperDetail'); });
/**
 * Application's main routes
 */
var Routes = function () { return (React.createElement(Switch, null,
    React.createElement(Route, { exact: true, path: routesPaths.newspaperPage, component: LazyNewspaperPage }),
    React.createElement(Route, { exact: true, path: routesPaths.newspaperMonthViewPage, component: LazyNewspaperPage }),
    React.createElement(Route, { exact: true, path: routesPaths.newspaperDetailPage, component: LazyNewspaperDetail }),
    React.createElement(Redirect, { from: "**", to: routesPaths.newspaperPageBase + "/date/" + dateToUrlDate(moment()) }))); };
export default Routes;
